import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';

class Filter extends Component {
    render() {
        const { areaList, ...rest } = this.props;
        
        const filters = [{
            name: '区域',
            key: 'areaId',
            type: 'select',
            typeProperty: {
                style: { width: 100 },
                list: areaList,
            }
        }, {
            name: '分管省份',
            key: 'provinceName',
            type: 'input',
        }, {
            name: '带教组长',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: { width: 140 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, roleCodes: 'CRC,CRCC,CRCM', workStatus: 'ALL' },
                url: API_URL.teaching.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/Filter.js